import * as ko from "knockout";
import {TBaseOrObservableOrFunctionType} from "../../index";
import {getAnyValue} from "../../util/misc";
import {lm} from "../../appContext";
import {storeObservable} from "../../util/sessionstore";
import heading_v2Html from './heading-v2.html?raw';

export let template = heading_v2Html;

interface IParams {
    heading: TBaseOrObservableOrFunctionType<string>
    description?: TBaseOrObservableOrFunctionType<string>
    cssClass: TBaseOrObservableOrFunctionType<string>
    badge?: TBaseOrObservableOrFunctionType<any>
    isWaiting?: KnockoutObservable<boolean>
}

export class viewModel {

    constructor(private params: IParams) {
    }

    private hasTranslation(obj: any): any {
        const value = getAnyValue(obj);
        const a = !!storeObservable('show.translation.key')();
        const b = lm.hasTranslation(value);
        const c = lm.t(value) != value;
        return a || b || c
    }

    private heading = ko.pureComputed(() => getAnyValue(this.params.heading))
    private description = ko.pureComputed(() => {
        if (this.params.description) {
            return getAnyValue(this.params.description)
        }
        const heading = getAnyValue(this.params.heading);
        if (!heading) {
            return null
        }
        if (['|', '((', '{{'].some(chars => heading.includes(chars))) {
            return null
        }
        return heading + '.description'
    })

}